import type { ITrip } from '@constants/types'
import useApi from '@hooks/useApi'
import type { NullableNumber, NullableString } from '@shared_types/global_types'
import { set } from 'lodash'

export default function useTripApi () {
  const { apiDelete, apiGet, apiGetArray, apiPut, apiPost } = useApi()

  const _opt = (successMessage?: string) => {
    return successMessage ? { successMessage } : undefined
  }

  const fetchCurrentTrip = async () => {
    const res = await apiGet<{ trip?: ITrip }>('api/trips/current')
    return res?.trip || null
  }

  const fetchTripGpx = async (id: number) => {
    const res = await apiGet<{ gpx?: NullableString }>(`api/trips/gpx/${id}`)
    return res?.gpx || null
  }

  const fetchCurrentTripWithGpx = async () => {
    let gpx: string | null = null
    const trip = await fetchCurrentTrip()
    if (trip?.id) {
      gpx = await fetchTripGpx(trip.id)
    }
    return { trip, gpx }
  }

  const formDataAsTrip = (data: FormData): Partial<ITrip> => {
    const trip: Partial<ITrip> = {}

    data.forEach((value, key) => {
      set(trip, key, value)
    })

    return trip
  }

  return {
    createTrip: async (data: FormData, successMessage?: string) => {
      const { lastID: id } = await apiPost<{ lastID: number }>('api/trips', data, _opt(successMessage))
      return { ...formDataAsTrip(data), id } as unknown as ITrip
    },
    updateTrip: async (id: number, data: FormData, successMessage?: string) => {
      await apiPut(`api/trips/${id}`, data, _opt(successMessage))
      return { ...formDataAsTrip(data), id } as unknown as ITrip
    },
    deleteTrip: (id: NullableNumber | undefined, successMessage?: string) => {
      return apiDelete(`api/trips/${id}`, {}, _opt(successMessage))
    },
    uploadTripGpx: (tripId: number, gpx: string, successMessage?: string) => {
      return apiPost('api/trips/gpx', { gpx, id: tripId }, _opt(successMessage))
    },
    updateTripGpx: (tripId: number, gpx: string, successMessage?: string) => {
      return apiPut(`api/trips/gpx/${tripId}`, { gpx, id: tripId }, _opt(successMessage))
    },
    fetchAllTrips: () => {
      return apiGetArray<ITrip>('api/trips')
    },
    fetchCurrentTrip,
    fetchCurrentTripWithGpx,
    fetchTripGpx
  }
}
